import { Directive, Inject, OnInit, DOCUMENT } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { lastValueFrom, Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { TheNaviGator } from 'src/app/services/the-navi-gator.service';
import { environment } from 'src/environments/environment';

@Directive()
export abstract class BaseInvitePage implements OnInit {

    /**
     * Make specific request to get InviteData based on Action or Actor
     */
    abstract getInviteData(): Promise<Observable<any>>;

    /**
     * Specific Id or Guid to use as Login hit for Id authentication
     */
    abstract loginIdentifier: string;



    constructor(@Inject(DOCUMENT) protected docElements: Document,
        protected localStorageService: LocalStorageService,
        protected authenticationService: AuthenticationService, protected route: ActivatedRoute,
        protected navigate: TheNaviGator,
        protected oidcSecurityService: OidcSecurityService,
        protected sessionStorageService: SessionStorageService) { }
    language!: string;

    ngOnInit() {
        // do not clear storage, THIS IS SLOW, AND HAPPENS AFTER THE INVITE STUFF
        this.authenticationService.logout(false);
        this.language = this.route.snapshot.queryParams['l']
        if (this.language) {
            this.localStorageService.Language = this.language;
        } else {
            this.language = this.localStorageService.Language;
        }
        this.docElements.documentElement.lang = this.language;

        this.authenticate();
    }

    authenticate() {
        let currentdomain: string = document.location.href.split('/')[2];
        let identityurl = environment.identityUrl;
        this.getInviteData()
            .then(value => {
                lastValueFrom(value)
                    .then(inviteData => {
                        this.authorization(currentdomain, identityurl, inviteData);
                    })
                    .catch(() => {
                        this.navigate.To_InviteNotFound();
                    });
            })
            .catch(() => {
                this.navigate.To_InviteNotFound();
            });
    }

    authorization(currentdomain: string, identityurl: string, data: any) {
        if (this.route.snapshot.queryParams['d']?.toLowerCase() == "true") {
            this.sessionStorageService.setDownloadReturnUrlForRequest = data.dossierId;
        } else {
            this.sessionStorageService.setViewerReturnUrlForRequest = data.dossierId;
        }
        if (data.idp && data.idp.toLowerCase() != 'default') {
            this.oidcSecurityService.authorize(null!, { customParams: { 'acr_values': "idp:" + data.idp, 'login_hint': this.loginIdentifier } });
        } else {
            this.oidcSecurityService.authorize(null!, { customParams: { 'login_hint': this.loginIdentifier } });
        }
    }
}
